export default __webpack_public_path__ + "static/media/rbg.b1b61ff7.jpg";